import React, { useContext } from 'react';
import FavouriteBtn from '../../atoms/FavouriteBtn/FavouriteBtn';
import LazyPicture from '../../atoms/LazyPicture';
import RouterLink from '../../atoms/RouterLink';
import { ReactComponent as IconChevronRightLight } from '../../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../../resources/icons/IconChevronLeftLight.svg';
import ScrollAnimation from 'react-animate-on-scroll';
import { injectImageResolution } from '../../../utils';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import useMobile from '../../../utils/useMobile';
import { Text } from '@sitecore-jss/sitecore-jss-react';
const ArticlesFeatureCarouselItem = _ref => {
  let {
    mobileList,
    activeTopPicks,
    toggleActiveTopPicks,
    url,
    image,
    title,
    objectID,
    category,
    introText,
    readmore,
    eventsAnalytics,
    params
  } = _ref;
  const imgSrc = injectImageResolution(`${image}`, 700, 460);
  const imgSrcMob = injectImageResolution(`${image}`, 460, 460);
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const isMobile = useMobile(767);
  return /*#__PURE__*/React.createElement("div", {
    key: objectID,
    className: "articlesFeatureCarousel__featured-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5 col-lg-5 col-xl-6 articlesFeatureCarousel__featured-image-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "articlesFeatureCarousel__featured-image-wrap"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: url,
    title: title,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['bannerClickAnalytics'], params), title)
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "articlesFeatureCarousel__featured-image",
    src: imgSrcMob,
    alt: url
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-0 col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 col-lg-6 col-xl-5 articlesFeatureCarousel__featured-info-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row flex-md-grow-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10 col-lg-12 d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "articlesFeatureCarousel__info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "articlesFeatureCarousel__text_sight"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.3
  }, category && category.join(' '))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.45
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "articlesFeatureCarousel__item-title_link",
    title: 'title',
    href: url,
    linktype: 'internal',
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), title)
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: mobileList && isMobile ? 'articlesFeatureCarousel__item-title_mobile' : 'articlesFeatureCarousel__item-title',
    field: {
      value: title
    }
  }))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.6
  }, /*#__PURE__*/React.createElement("p", {
    className: mobileList && isMobile ? 'articlesFeatureCarousel__text_mobile' : 'articlesFeatureCarousel__text'
  }, introText, ' ')), /*#__PURE__*/React.createElement("div", {
    className: "articlesFeatureCarousel__featured-fav-wrapper"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.7
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn-tertiary btn-tertiary_articlesFeatureCarousel",
    title: readmore,
    href: url,
    linktype: 'internal',
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['readMoreAnalytics'], params), [title, readmore])
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-tertiary__text"
  }, readmore), rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null))), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: objectID,
    multiplyButton: true,
    activeListOnSamePage: activeTopPicks,
    componentPrimaryColor: "var(--articlesFeatureCarousel-theme-hex-background-color)",
    componentPrimaryColorActive: "var(--articlesFeatureCarousel-theme-hex-active-color)",
    classes: 'articlesFeatureCarousel__fav-btn articlesFeatureCarousel__fav-btn_desktop',
    analyticsClick: e => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['addToFavAnalytics'], params), `${e} : ${title}`);
      toggleActiveTopPicks(objectID);
    }
  })))))));
};
export default ArticlesFeatureCarouselItem;